import React from 'react';
import clsx from 'clsx';
import styles from './GalleryGrid.scss';
export function GalleryGrid(_ref) {
  let {
    images,
    layout = 'masonry',
    className,
    imagesFit = 'contain'
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.galleryGrid, styles[layout], className)
  }, images.map((image, index) => /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.galleryGridItem, styles[layout]),
    key: image + index
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.galleryGridItemImage,
    style: {
      objectFit: imagesFit
    },
    src: image,
    alt: image
  }))));
}
//# sourceMappingURL=GalleryGrid.js.map